import React from 'react';
import SashiDo from 'lib/SashiDo';
import moment from 'moment';
import DashboardView from 'dashboard/DashboardView.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import PreLoader from 'components/PreLoader/PreLoader.react';
import HeatMap from './Requests/HeatMap.react';
import Graph from './Requests/Graph.react';

import settingsStyles               from 'dashboard/Settings/Settings.scss';
import styles from './Metrics.scss';

export default class Requests extends DashboardView {
  constructor(props) {
    super(props);

    this.section = 'Metrics';
    this.subsection = 'Requests';

    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    await SashiDo.metricsCloudRequests(this.props.currentApp.id).then((data) => {
      const { metrics } = data;

      const labels = [];
      const datasets = [];

      metrics.forEach((item) => {
        labels.push(item.timestamp);
        datasets.push(item.value || 0);
      });

      const result = metrics.reduce((r, a) => {
        const date = moment(a.timestamp).format('YYYY-MM');
        r[date] = r[date] || 0;
        r[date] += a.value || 0;
        return r;
      }, {});

      this.state.cloudMetrics = {
        cloudMetricsOriginalData: metrics,
        last12Months: {
          labels: Object.keys(result),
          datasets: [
            {
              name: 'Cloud Requests',
              values: Object.keys(result).map(key => result[key]),
            }
          ]
        },
        last30Days: {
          labels: labels.slice(1).slice(-30),
          datasets: [
            {
              name: 'Cloud Requests',
              values: datasets.slice(1).slice(-30),
            }
          ]
        },
      }
    });


    await SashiDo.metricsApiRequests(this.props.currentApp.id).then((data) => {
      const { metrics } = data;

      const labels = [];
      const datasets = [];

      metrics.forEach((item) => {
        labels.push(item.timestamp);
        datasets.push(item.value || 0);
      });

      const result = metrics.reduce((r, a) => {
        const date = moment(a.timestamp).format('YYYY-MM');
        r[date] = r[date] || 0;
        r[date] += a.value || 0;
        return r;
      }, {});

      this.state.apiMetrics = {
        apiMetricsOriginalData: metrics,
        last12Months: {
          labels: Object.keys(result),
          datasets: [
            {
              name: 'API Requests',
              values: Object.keys(result).map(key => result[key]),
            }
          ]
        },
        last30Days: {
          labels: labels.slice(1).slice(-30),
          datasets: [
            {
              name: 'API Requests',
              values: datasets.slice(1).slice(-30),
            }
          ]
        }
      }
    });

    const { apiMetrics } = this.state;
    const { cloudMetrics } = this.state;

    const stackedData = {
      last12Months: {
        labels: apiMetrics.last12Months.labels,
        datasets: [
          apiMetrics.last12Months.datasets[0],
          cloudMetrics.last12Months.datasets[0],
        ]
      },
      last30Days: {
        labels: apiMetrics.last30Days.labels,
        datasets: [
          apiMetrics.last30Days.datasets[0],
          cloudMetrics.last30Days.datasets[0],
        ]
      }
    }

    const heatMapData = {};

    const { apiMetricsOriginalData } = this.state.apiMetrics;
    const { cloudMetricsOriginalData } = this.state.cloudMetrics;

    apiMetricsOriginalData.map((item, i) => {
      heatMapData[moment(item.timestamp).unix()] = item.value + cloudMetricsOriginalData[i].value;
    });

    this.setState({
      loading: false,
      stackedData,
      heatMapData,
    });
  }

  renderContent() {
    const { props } = this;
    const { heatMapData, stackedData, cloudMetrics, apiMetrics } = this.state;
    let classes = [settingsStyles.settings_page, settingsStyles.default];

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.section} subsection={this.subsection} />
        <PreLoader loading={this.state.loading}>
          <div className={settingsStyles.holder}>
            <div className={[styles.holder, styles.withTopPadding].join(' ')}>
              {
                heatMapData &&
                  <HeatMap
                    data={heatMapData}
                    title='Daily requests'
                    unit='Requests'
                    dataFormat='0,[0]'
                    tooltip='The total amount of requests per day for the last 12 months. Collecting since Aug 20 2016 and updating every hour.'
                  />
              }

              <div className={styles.separator} />

              {
                stackedData &&
                  <Graph {...props}
                    data={stackedData}
                    title='Total Requests'
                    tooltip='Collecting since Aug 20 2016 and updating every hour.'
                    unit='Requests'
                    dataFormat='0.[0] a'
                    stacked={true}
                    colors={['#98d85b', '#28a745']}
                  />
              }

              <div className={styles.separator} />

              {
                apiMetrics &&
                  <Graph
                    {...props}
                    data={apiMetrics}
                    title='API Requests'
                    tooltip='Collecting since Aug 20 2016 and updating every hour.'
                    unit='Requests'
                    dataFormat='0.[0] a'
                    colors={['#98d85b']} />
              }

              <div className={styles.separator} />

              {
                cloudMetrics &&
                  <Graph
                    {...props}
                    data={cloudMetrics}
                    title='Cloud Requests'
                    tooltip='Collecting since Aug 20 2016 and updating every hour.'
                    unit='Requests'
                    dataFormat='0.[0] a'
                    colors={['#98d85b']} />
              }
            </div>
          </div>
        </PreLoader>
      </div>
    );
  }
}
